<div role="dialog" aria-modal="true" aria-labelledby="modal-title-assignment-reconfirm">
    <div class="modal-header">
      <h2 id="modal-title-assignment-reconfirm" class="modal-title h4">Plan Assignment Reconfirmation</h2>
    </div>
    <form #ngForm="ngForm" (ngSubmit)="ngForm.valid && submit()">
      <div class="modal-body">
        <div *ngIf="reconfirmationType === PlanReconfirmationTypeEnum.PartiallyFulfilled">
          <b>{{ message }}</b>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary" data-test="Submit">OK</button>
        <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
